import React, { useState } from 'react';
import Card, { CardRow } from 'components/styleguide/card/Card';
import Sheet from 'components/styleguide/sheet_modal/Sheet';
import InputField from 'components/styleguide/input_field/InputField';
import { useEditableSheet } from 'components/styleguide/sheet_modal/useEditableSheet';
const styles = require('../onboarding-cards.module.scss');

interface CompanyLinksCardProps {
  website_url: string;
  url: string;
}

const CompanyLinksCard: React.FC<CompanyLinksCardProps> = ({
  website_url,
  url,
}) => {
  const [display, setDisplay] = useState({
    website_url: website_url || '',
  });

  const sheet = useEditableSheet({
    url,
    payloadKey: 'company',
    onSuccess: (data) => {
      setDisplay({
        website_url: data.website_url || '',
      });
    },
  });

  const handleEditClick = (action: string) => {
    if (action === 'edit') {
      sheet.open('Edit company links', {
        website_url: display.website_url,
      });
    } else if (action === 'add') {
      sheet.open('Add company link', {
        website_url: undefined,
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    sheet.handleFormChange(e.target.name, e.target.value);
  };

  const dataFilled = display.website_url;

  return (
    <>
      <Card
        title="Company links"
        iconName="link"
        context="company"
        tag={dataFilled ? undefined : { variant: 'warning', icon: 'circleAlert', children: 'Missing' }}
        onAdd={() => handleEditClick("add")}
        onEdit={() => handleEditClick("edit")}
      >
        {dataFilled && (
          <CardRow context="company">
            <div className={styles.fieldGrid}>
              <div className={styles.field}>
                <p className={styles.label}>Website</p>
                <p className={styles.value}>{display.website_url}</p>
              </div>
          </div>
          </CardRow>
        )}
      </Card>

      {sheet.isOpen && (
        <Sheet
          title={sheet.sheetTitle}
          onClose={sheet.close}
          context="company"
          showCancelButton={false}
          continueButtonText="Save"
          onContinue={sheet.handleSave}
        >
          <div className={styles.form}>
            <InputField
              label="Website"
              placeholder="e.g. https://www.company.com"
              name="website_url"
              value={sheet.formData.website_url || ''}
              onChange={handleInputChange}
              size="L"
              error={sheet.getError('website_url')}
            />
          </div>
        </Sheet>
      )}
    </>
  );
};

export default CompanyLinksCard;
